import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { Uuid } from '../../../../../../../graphql';
import { EditTrackerService } from '../../../../../../core/services/edit-tracker.service';
import { PermissionService } from '../../../../../../core/services/permission';
import { Contact } from '../../../../../../data/models';
import { ContactApiService } from '../../../../../../data/repositories/contacts/contacts.api.service';
import { SecondaryNavStoreService } from '../../secondary-nav.store.service';
import { SecondaryNavContactService } from '../secondary-nav-contact.service';

@Component({
    selector: 'app-topbar-contact-info',
    templateUrl: './topbar-contact-info.component.html',
    styleUrls: ['./topbar-contact-info.component.scss', '../../topbar-info/topbar-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, NgSelectModule, FormsModule],
})
export class TopbarContactInfoComponent {
    #permissionService = inject(PermissionService);
    #editTrackerService = inject(EditTrackerService);
    #secondaryNavContactService = inject(SecondaryNavContactService);
    #navState = inject(SecondaryNavStoreService);
    #api = inject(ContactApiService);
    canEditContactGroup$ = this.#permissionService.getState('contacts.maintain-contacts.edit-contact-group');
    canEditContactType$ = this.#permissionService.getState('contacts.maintain-contacts.edit-contact-type');
    contact$ = this.#navState.currentContact.obs$;
    contactTypes$ = this.#secondaryNavContactService.getContactTypes();
    contactGroups$ = this.#secondaryNavContactService.getContactGroups();
    isTracking$ = this.#editTrackerService.isTracking$;

    setGroup(group: string) {
        const contact = this.#navState.currentContact.value();
        if (contact) {
            this.#api.updateContacts({ models: [{ iD_Contact: contact.ID_Contact as Uuid, contactGroup: group }] }).subscribe((x) => {
                const updated = x.data?.updateContacts.contact?.at(0);
                if (!updated?.ContactGroup) return;
                contact.ContactGroup = updated.ContactGroup;
                this.#secondaryNavContactService.onContactUpdate(contact);
            });
        }
    }

    setType(type: string) {
        const contact = this.#navState.currentContact.value();
        if (contact) {
            this.#api.updateContacts({ models: [{ iD_Contact: contact.ID_Contact as Uuid, contactType: type }] }).subscribe((x) => {
                const updated = x.data?.updateContacts.contact?.at(0);
                if (!updated?.ContactType) return;
                contact.ContactType = updated.ContactType;
                this.#secondaryNavContactService.onContactUpdate(contact);
            });
        }
    }
}
